const Constants = {
    MAX_ROOM: 8,
    MAX_ADULTS: 10,
    MIN_ADULTS: 1,
    MAX_CHILDREN: 10,
    MIN_CHILDREN: 0,
    MAX_CHILDREN_AGE: 12
  }
  
  export default Constants
  